import AvenueDatePicker from "../inputs/AvenueDatePicker";
import SelectableDropdown from "./SelectableDropdown";
import { DropdownSelect } from "@avenueops/web-components";
import { ProcessTimeFrame } from "@prisma/client";
import { useProcessTableTimeFrame } from "context/ProcessTableContext";
import { startOfYesterday, endOfToday } from "date-fns";
import _ from "lodash";
import React from "react";

interface Props {
  square?: boolean;
}

export default function ProcessTimeFrameSelector({ square }: Props) {
  const [{ timeFrame, timeFrameStartIncl, timeFrameEndExcl }, setTimeFrame] = useProcessTableTimeFrame();

  const updateTimeFrame = (newTimeFrame: ProcessTimeFrame | undefined) => {
    if (!newTimeFrame) {
      return;
    }
    if (newTimeFrame === ProcessTimeFrame.CUSTOM) {
      setTimeFrame({ timeFrame: newTimeFrame, timeFrameStartIncl: startOfYesterday(), timeFrameEndExcl: endOfToday() });
    } else {
      setTimeFrame({ timeFrame: newTimeFrame, timeFrameStartIncl: undefined, timeFrameEndExcl: undefined });
    }
  };

  const updateTimeFrameStartIncl = (newTimeFrameStartIncl: Date) => {
    setTimeFrame({ timeFrame, timeFrameStartIncl: newTimeFrameStartIncl, timeFrameEndExcl });
  };

  const updateTimeFrameEndExcl = (newTimeFrameEndExcl: Date) => {
    setTimeFrame({ timeFrame, timeFrameEndExcl: newTimeFrameEndExcl, timeFrameStartIncl });
  };

  return (
    <div className="flex flex-row gap-2 z-100 relative overflow-visible">
      <div>
        <DropdownSelect
          name="time_frame_selector"
          type="BUTTON"
          placeholder="Select time Frame"
          options={Object.values(ProcessTimeFrame).map((timeFrameOption: ProcessTimeFrame) => {
            return { value: timeFrameOption, label: stringifyTimeFrame(timeFrameOption) };
          })}
          selectedValue={timeFrame}
          onChange={(val?: string) => updateTimeFrame((val ?? "") as ProcessTimeFrame)}
        />
      </div>

      {timeFrame === ProcessTimeFrame.CUSTOM ? (
        <div className="inline-flex items-center z-10 gap-2">
          <AvenueDatePicker value={timeFrameStartIncl} onChange={updateTimeFrameStartIncl} />
          <div className="text-gray-400 font-semibold text-sm">to</div>
          <AvenueDatePicker value={timeFrameEndExcl} onChange={updateTimeFrameEndExcl} />
        </div>
      ) : null}
    </div>
  );
}

export function stringifyTimeFrame(timeFrame: ProcessTimeFrame) {
  return _.startCase((timeFrame as string)?.replaceAll("_", " ").toLowerCase());
}
